import React, { Component } from "react";
import Dropzone from "react-dropzone";

export class LogoUploader extends Component {
    state = {
        file: undefined
    };

    // componentWillMount() {
    //     const { currentImage } = this.props;
    //     if(defaultCompanyImage === currentImage) {
    //     }
    // }

    _blobToDataURL(blob) {
        let that = this;
        var a = new FileReader();
        a.onload = function (e) {
            // callback(e.target.result);
            that.setState({
                file: e.target.result
            });
        }
        a.readAsDataURL(blob);
    }

    _onDrop = files => {
        this._blobToDataURL(files[0]);
    };

    render() {
        const { currentImage, ImageRef } = this.props;
        //const messages = {
        //    DEFAULT: "Drop your photo here or tap to select.",
        //    DRAGOVER: "Drop your photo",
        //    INVALID_FILE_TYPE: "Only images allowed.",
        //    INVALID_IMAGE_SIZE: "Your photo must be larger than 30px."
        //};
        const imagePreview = (this.state.file ? this.state.file : currentImage);

        // console.log("imagePreview", imagePreview);

        return (
            <div>
                <Dropzone
                    accept="image/jpeg, image/png, image/jpg"
                    multiple={false}
                    onDrop={this._onDrop}
                    style={{
                        borderColor: "#E0E0E0",
                        borderWidth: "2px",
                        borderStyle: "dashed",
                        width: "204px",
                        height: "204px",
                        cursor: "pointer",
                        padding: "2px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <img
                        alt=""
                        src={imagePreview}
                        style={{ maxWidth: "200px", maxHeight: "200px", margin: "auto" }} />
                </Dropzone>
                <input type="hidden" ref={ImageRef} value={this.state.file || ''} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/LogoUploader.js